import { memo } from 'react';
import { Sidebar } from '../../common/sideBar';
import { CgLogIn, CgLogOut } from 'react-icons/cg';
import { NavigationItem } from '../../../hooks/useNavigationItems';

// ============= Types =============
interface SidebarManagerProps {
  showLeftSidebar: boolean;
  isLeftSidebarOpen: boolean;
  onSidebarToggle: () => void;
  navigationItems: NavigationItem[];
}

// ============= Constants =============
const SIDEBAR_ICONS = {
  left: {
    open: <CgLogOut size={18} />,
    closed: <CgLogIn size={18} />,
  },
} as const;

// ============= Component =============
/**
 * SidebarManager Component
 * Manages the left sidebar display and state
 */
export const SidebarManager = memo<SidebarManagerProps>(
  ({
    showLeftSidebar,
    isLeftSidebarOpen,
    onSidebarToggle,
    navigationItems,
  }) => {
    if (!showLeftSidebar) return null;

    return (
      <Sidebar
        isOpen={isLeftSidebarOpen}
        setIsOpen={onSidebarToggle}
        position="left"
        items={navigationItems}
        toggleIcon={SIDEBAR_ICONS.left}
      />
    );
  }
);

SidebarManager.displayName = 'SidebarManager';
